'use strict'

define ['./overflow.scss'], () ->
  (RentappService, $state, $document, $parse) ->
    restrict: "E"
    template: require("./overflow.jade")
    scope:
      maxChar: '@'
      displayText: '@'
      type: '@'
    link: (scope, elem, attr) ->
      scope.toggled = false
      scope.use_overflow = false
      scope.character_limit = Number(scope.maxChar) or 34 #the default max character length #

      elem.bind 'click', (e) ->
        e.stopPropagation()
        return

      $document.bind 'click', ->
        scope.toggled = false
        scope.$apply()

      if scope.displayText
        if scope.displayText.length > scope.character_limit
          scope.use_overflow = true
          scope.content = scope.displayText.substring(0, scope.character_limit - 1) + "..."
      else
        scope.content = scope.displayText

      scope.toggleToolTip = () ->
        scope.toggled = !scope.toggled



// WEBPACK FOOTER //
// ./directives/overflow/overflow.coffee